export default "__VITE_ASSET__7615cd10__"